import cx from "classnames";

import { Accordion, AccordionProps } from "atoms";

export type AccordionItem = Omit<AccordionProps, "index">;

export type AccordionListProps = {
  items: AccordionItem[];
  className?: string;
  contentClassName?: string;
};

export const AccordionList = ({
  items,
  className,
  contentClassName,
}: AccordionListProps) => {
  return (
    <div
      className={cx("w-full border-t", className)}
      role="region"
      aria-label="Accordion list"
    >
      {items.map((item, index) => (
        <Accordion
          key={index}
          {...item}
          index={index}
          contentClassName={contentClassName}
        />
      ))}
    </div>
  );
};
